import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import CookieBanner from './components/CookieBanner';
import HomePage from './components/HomePage';
import Infrastruktur from './components/Infrastruktur';
import Prognosen from './components/Prognosen';
import Versicherungen from './components/Versicherungen';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, getLocaleFromPath } from './i18n/config';

const App = () => {
  const location = useLocation();
  const activeLocale = getLocaleFromPath(location.pathname);

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />} />

        {SUPPORTED_LOCALES.map((locale) => (
          <Route key={`${locale}-home`} path={`/${locale}`} element={<HomePage locale={locale} />} />
        ))}

        {SUPPORTED_LOCALES.map((locale) => (
          <Route key={`${locale}-insurance`} path={`/${locale}/versicherungen`} element={<Versicherungen />} />
        ))}
        {SUPPORTED_LOCALES.map((locale) => (
          <Route key={`${locale}-forecasts`} path={`/${locale}/prognosen`} element={<Prognosen />} />
        ))}
        {SUPPORTED_LOCALES.map((locale) => (
          <Route key={`${locale}-infra`} path={`/${locale}/infrastruktur`} element={<Infrastruktur />} />
        ))}

        <Route path="/versicherungen" element={<Navigate to={`/${DEFAULT_LOCALE}/versicherungen`} replace />} />
        <Route path="/prognosen" element={<Navigate to={`/${DEFAULT_LOCALE}/prognosen`} replace />} />
        <Route path="/infrastruktur" element={<Navigate to={`/${DEFAULT_LOCALE}/infrastruktur`} replace />} />

        <Route path="*" element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />} />
      </Routes>

      <CookieBanner locale={activeLocale} />
    </>
  );
};

export default App;
